<template>
  <teleport to="header">
    <CompHeaderSimple v-if="headerType === 'simple'" />
    <CompHeader v-else-if="headerType === 'normal'" />
  </teleport>
  <router-view></router-view>

  <modalDialog
    :title="globalStore.modal.title"
    :show-dialog="globalStore.modal.isShow"
    @close-dialog="globalMethods.closeModalDialog"
  >
    <div style="width: 416px">
      {{
        globalStore.modal.description ||
        '一時的なエラーによりリクエストが完了しませんでした。インターネットの接続を確認しもう一度お試しください。'
      }}
    </div>
  </modalDialog>

  <modalInvite
    v-if="globalStore.user.id"
    :show-dialog="globalStore.modalInvite.isShow"
    @close-dialog="globalMethods.closeModalInvite"
  >
    <div style="width: 416px"></div>
  </modalInvite>

  <modalMsgFuncAgreement
    v-if="globalStore.user.id"
    :seller-id="globalStore.seller.id"
    :show-dialog="globalStore.modalMsgFuncAgreement.isShow"
    @close-dialog="globalMethods.closeModalMsgFuncAgreement"
  >
  </modalMsgFuncAgreement>

  <toast />

  <teleport to="footer">
    <div v-if="showFooter" class="w-full text-xs h-16 border-t border-gray-12">
      <div class="flex justify-between py-6 px-8">
        <div>
          <ul class="flex">
            <li class="border-r pr-4">
              <a
                href="https://imitsu.jp/terms"
                target="_blank"
                class="flex items-center"
              >
                <div class="text-gray-62 body-sm">利用規約</div>
              </a>
            </li>
            <li class="border-r px-4">
              <a href="https://www.imitsu-cloud.jp/termspaid" target="_blank">
                <span class="text-gray-62 body-sm">有料プラン利用規約</span>
              </a>
            </li>
            <li class="border-r px-4">
              <a href="https://imitsu.jp/privacypolicy" target="_blank">
                <span class="text-gray-62 body-sm">プライバシーポリシー</span>
              </a>
            </li>
            <li class="border-r px-4">
              <a
                href="https://safe-falcon-d33.notion.site/c69d1578dc18433eb2176ed9747f056d"
                target="_blank"
                class="flex items-center"
              >
                <div class="mr-1 text-gray-62 body-sm">
                  PRONIパートナー向け禁止事項
                </div>
                <div>
                  <img src="@/assets/icons/ExternaLlink.svg" />
                </div>
              </a>
            </li>
            <li class="px-4">
              <a
                href="https://www.proni.co.jp/"
                target="_blank"
                class="flex items-center"
              >
                <div class="mr-1 text-gray-62 body-sm">運営会社</div>
                <div>
                  <img src="@/assets/icons/ExternaLlink.svg" />
                </div>
              </a>
            </li>
          </ul>
        </div>
        <div class="text-gray-62 body-sm">&copy;PRONI Inc.</div>
      </div>
    </div>
  </teleport>
</template>

<script>
import { reactive, provide, onMounted, computed, watch } from 'vue';
import { useRouter } from 'vue-router';
import { VueCookieNext } from 'vue-cookie-next';
import axios from '@/utils/axiosAuth.js';
import modalDialog from '@/components/modalDialog.vue';
import modalMsgFuncAgreement from '@/components/modalMsgFuncAgreement.vue';
import modalInvite from '@/components/modalInvite.vue';
import toast from '@/components/toast.vue';
import CompHeaderSimple from '@/views/_commons/CompHeaderSimple.vue';
import CompHeader from '@/views/_commons/CompHeader.vue';
import * as Sentry from '@sentry/vue';

export default {
  components: {
    modalDialog,
    toast,
    modalMsgFuncAgreement,
    modalInvite,
    CompHeaderSimple,
    CompHeader,
  },
  setup() {
    const router = useRouter();

    const globalStore = reactive({
      modal: {
        display: false,
        title: '',
        description: '',
        callback: null,
      },
      modalInvite: {
        isShow: false,
        isHover: false,
      },
      modalMsgFuncAgreement: {
        isShow: false,
      },
      toast: {
        items: [],
        latestId: 0,
      },
      user: {},
      seller: {},
      notification: {
        isShow: false,
        isHover: false,
        count: 0,
      },
      todoList: {
        todos: [],
      },
    });

    const globalMethods = {
      isToast: (content, options = {}) => {
        let item = {
          id: globalStore.toast.latestId,
          content: content,
        };
        globalStore.toast.latestId++;
        globalStore.toast.items.push(item);
        setTimeout(() => {
          globalMethods.clearToast(item.id);
        }, options.timeout || 3000);
      },

      clearToast: (id) => {
        let idx = -1;
        for (const [i, item] of Object.entries(globalStore.toast.items)) {
          if (item.id === id) {
            idx = i;
          }
        }
        if (idx !== -1) {
          globalStore.toast.items.splice(idx, 1);
        }
      },

      updateModal: (isShow, title = '', description = '', callback = null) => {
        globalStore.modal.isShow = isShow;
        globalStore.modal.title = title;
        globalStore.modal.description = description;
        globalStore.modal.callback = callback;
      },

      sendLog: (error) => {
        Sentry.captureException(error);
      },

      closeNotification: () => {
        globalStore.notification.isShow = false;
      },
      closeModalDialog: () => {
        globalStore.modal.isShow = false;
        if (globalStore.modal.callback) {
          globalStore.modal.callback();
        }
        globalStore.modal.callback = null;
      },
      closeModalMsgFuncAgreement: () => {
        globalStore.modalMsgFuncAgreement.isShow = false;
      },
      closeModalInvite: () => {
        globalStore.modalInvite.isShow = false;
      },
      logout: async () => {
        await axios
          .post('/auth/logout')
          .then(() => {
            VueCookieNext.removeCookie('accessToken');
            router.push({ name: 'Login' });
          })
          .catch((e) => {
            VueCookieNext.removeCookie('accessToken');
            router.push({ name: 'Login' });
            globalMethods.updateModal(
              true,
              'リクエストが完了しませんでした。',
              e.systemMessage || '',
              e.callback
            );
            globalMethods.sendLog(e);
          });
      },

      loginToBuyer: async () => {
        await axios
          .post('/account-switch')
          .then((response) => {
            if (!response) throw new Error('');
            window.open(response.data.redirect_url, '_blank').focus();
          })
          .catch((e) => {
            globalMethods.updateModal(
              true,
              'URLが正しくないか、通信エラーが発生しました。',
              e.systemMessage || '',
              e.callback
            );
            globalMethods.sendLog(e);
          });
      },
    };

    async function getHeaderData() {
      await axios.post('/auth/me').then((response) => {
        Object.assign(globalStore.user, response.data);
      });
      await axios
        .get('/sellers')
        .then((response) => {
          if (response.data.data && response.data.data.length) {
            Object.assign(globalStore.seller, response.data.data[0]);
          }
        })
        .catch((e) => {
          globalMethods.updateModal(
            true,
            'URLが正しくないか、通信エラーが発生しました。',
            e.systemMessage || '',
            e.callback
          );
          globalMethods.sendLog(e);
        });
      if (globalStore.seller.id) {
        await axios
          .get(`/sellers/${globalStore.seller.id}`)
          .then((response) => {
            if (response.data && response.data.data) {
              if (!response.data.data.seller_company) {
                // 調査中の受注者
                VueCookieNext.removeCookie('accessToken');
                return router.push({ name: 'Login' });
              }

              globalStore.notification.count =
                response.data.data.unread_notification_number;
              globalStore.todoList.todos = response.data.data.todoList;
              if (response.data.data.has_msg_func_agreed === null) {
                globalStore.modalMsgFuncAgreement.isShow = true;
              }
            }
          })
          .catch((e) => {
            globalMethods.updateModal(
              true,
              'URLが正しくないか、通信エラーが発生しました。',
              e.systemMessage || '',
              e.callback
            );
            globalMethods.sendLog(e);
          });
      }
    }
    function setDataLayerForGA() {
      if (globalStore.user.id) {
        // GA：PV時にuserIdを見る為、予めdataLayerにuseridを付与
        window.dataLayer = window.dataLayer || [];
        if (!window.dataLayer.some((item) => item.pvUserId)) {
          window.dataLayer.push({ pvUserId: globalStore.user.id });
        }
      }
    }
    const routeName = computed(() => {
      return router.currentRoute.value.name;
    });
    const path = computed(() => {
      return router.currentRoute.value.path;
    });
    const showFooter = computed(() => {
      return router.currentRoute.value.meta.showFooter || false;
    });
    const headerType = computed(() => {
      return router.currentRoute.value.meta.headerType || '';
    });

    watch(path, async (currentPath, prevPath) => {
      if (
        routeName.value !== 'Login' &&
        currentPath !== prevPath &&
        !router.currentRoute.value.meta.isPublic
      ) {
        await getHeaderData();
        setDataLayerForGA();
      }
    });

    provide('globalStore', globalStore);
    provide('globalMethods', globalMethods);

    onMounted(async () => {
      if (!router.currentRoute.value.meta.isPublic) {
        await getHeaderData();
        setDataLayerForGA();
      }
    });
    return {
      globalStore,
      globalMethods,
      headerType,
      showFooter,
    };
  },
};
</script>
<style lang="scss" scoped></style>
